export default theme => ({
  input: {
    height: '34px',
    borderColor: theme.colors.threatAssocGray,
  },
  input__criticality: {
    width: '58px',
  },
});
